import styled from "@emotion/styled"
import { colorContrastLow, spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import type { StandardEquipmentCategory, StandardEquipmentItem } from "@slfinrtl/ui-bff-routes"
import { useCallback } from "react"
import { Modal } from "src/context/modal/Modal"
import type { ModalProps } from "src/context/modal/ModalProvider"
import { useModal } from "src/context/modal/useModal"
import { RichEquipmentCategoryItemDetails } from "./rich/RichEquipmentCategoryItemDetails"
import { RichEquipmentItem } from "./rich/RichEquipmentItem"
import { SimpleEquipmentItem } from "./simple/SimpleEquipmentItem"

interface EquipmentCategoryProps {
	category: StandardEquipmentCategory
}

export const EquipmentCategory = ({ category }: EquipmentCategoryProps) => {
	const showEquipmentCategoryDetailsModal = useModal<EquipmentCategoryDetailProps>(EquipmentCategoryDetailsModal)
	const handleClick = useCallback(
		(item: StandardEquipmentItem) => showEquipmentCategoryDetailsModal({ item }),
		[showEquipmentCategoryDetailsModal],
	)

	return (
		<Category>
			{category.items.map((entry) => {
				return !entry.description?.length && !entry.imageSourceSets?.length ? (
					<SimpleEquipmentItem key={entry.name} item={entry} onClick={handleClick} />
				) : (
					<RichEquipmentItem key={entry.name} item={entry} onClick={handleClick} />
				)
			})}
		</Category>
	)
}

const Category = styled.div`
	border-top: 1px solid ${colorContrastLow};
	padding-bottom: ${spacingStaticSm};
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: stretch;
`

interface EquipmentCategoryDetailProps {
	item: StandardEquipmentItem
}
type Props = ModalProps<EquipmentCategoryDetailProps>

const EquipmentCategoryDetailsModal = ({ id, modalProps }: Props) => {
	const { item } = modalProps

	return (
		<Modal id={id} width="wide">
			<RichEquipmentCategoryItemDetails item={item} />
		</Modal>
	)
}
